/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Proof_FormatsInputs */

const vi_tea_purchase_payment_proof_formats = /** @type {(inputs: Tea_Purchase_Payment_Proof_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG tối đa 10MB`)
};

/**

* @param {Tea_Purchase_Payment_Proof_FormatsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_proof_formats = /** @type {((inputs?: Tea_Purchase_Payment_Proof_FormatsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Proof_FormatsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_proof_formats(inputs)
});